export const roomTypeData = [
  { 1: "Stüdyo" },
  { 2: "1" },
  { 3: "1+1" },
  { 5: "2+1" },
  { 6: "2+2" },
  { 7: "3+1" },
  { 8: "3+2" },
  { 9: "4+1" },
  { 10: "4+2" },
  { 11: "5" },
  { 12: "5+1" },
  { 13: "5+2" },
  { 14: "5+3" },
  { 15: "5+4" },
  { 16: "6+1" },
  { 17: "6+2" },
  { 22: "6+3" },
  { 23: "6+4" },
  { 18: "7+1" },
  { 20: "7+2" },
  { 21: "7+3" },
  { 19: "8+" },
];
